import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import {
  selectVulnTemplateDetail
} from 'store/KnowledgeBase/selectors';
import ExpandableWrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ExpandableWrapper';
import useExpandable from 'Hooks/useExpandable';
import { Wrapper, TextField } from './styled';
import { updateVulnTemplate } from 'Screens/Contextualization/KnowledgeBase/actions/Actions';

const TAB = 'general';
const ID = 'externalID';

const ExternalId = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const vulnTemplate = useSelector(selectVulnTemplateDetail);
  const id = get(vulnTemplate, '_id', 0);
  const externalId = get(vulnTemplate, 'external_id', '');
  const isExpanded = useExpandable(TAB, ID, externalId, vulnTemplate?.id);
  const [externalIdValue, setExternalIdValue] = useState(externalId);

  useEffect(() => {
    setExternalIdValue(externalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <ExpandableWrapper defaultValue={ isExpanded } title={ intl.formatMessage({ id: 'manage.detail.tab.general.externalID' }) } tab={ TAB } id={ ID }>
      <Wrapper>
        <TextField
          width="100%"
          height="38px"
          placeholder="125798926"
          value={ externalIdValue }
          onChange={ (value) => setExternalIdValue(value) }
          defaultValue={ externalIdValue }
          onBlur={ () => dispatch(updateVulnTemplate(id, { external_id: externalIdValue })) }
        />
      </Wrapper>
    </ExpandableWrapper>
  );
};

export default ExternalId;
